export default {
  hr: "hr",
  hrs: "hrs",
  min: "min",
  mins: "mins",
  byAdmin: "(durch Admin)",
  byAdminComparator: "durch Admin",
};
